<div class="message-wrapper" [class.send]="(displayCounterOfferForm) ? true : userMessage" #offerChatMessage
  [class.recived]="(displayCounterOfferForm) ? false : !userMessage" [class.mobile]="topService.isMobile">
  <div class="message" [class.new]="isLastEvent" [class.read]="!isLastEvent" [class.typing]="isTyping"
    [class.z-index]="goodForDropdown?.expanded" [class.previous-accepted]="previousOfferWasAccepted"
    [class.current-accepted]="previousAcceptedIndex >=0 && isCounterpartyPriorOffer" [class.from-vendor]="isVendor"
    [class.accepted-dialog-active]="setAcceptedDialogActive()"
    [class.unaccepted]="previousAcceptedIndex >= 0 && offerService.selectedOffer.offerEvents[previousAcceptedIndex - 1].id == offerEvent.id">
    <ng-container
      *ngIf="!displayCounterOfferForm && !isTyping && !offerWasAccepted && !offerWasTaken && !offerWasRejected && !orderWasCreated && !offerHasExpired && !offerWasCancelled && !isEditOffer">
      <div class="counter animated" [class.flipmessage]="isEditOfferAnimate">
        <div class="counter-header">
          <div class="counter-header-left">
            <h4 class="naming">
              <ng-container *ngIf="metadata?.isFinal">Final Offer</ng-container>
              <span *ngIf="!metadata?.isFinal">
                {{getOfferEventTypeTitle()}}
              </span>
            </h4>
          </div>

          <div class="counter-header-right">
            <div class="timer" *ngIf="isLastEvent && !previousOfferWasAccepted">
              <span>
                <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
                  [utcDate]="offerService.selectedOffer?.expiresOn" [source]="GenericCountdownSourceEnum.counteroffer"
                  (onFinish)="countdownFinished()">

                </app-generic-countdown>
                <span> left</span>
              </span>
              <i>
                <svg height="24" width="24">
                  <use xlink:href="#icon-timer"></use>
                </svg>
              </i>
            </div>
          </div>
        </div>

        <div class="counter-diagram">
          <div class="counter-diagram-left">
            <span class="name">{{(isBuyer) ? 'List Price' : 'Cost'}}</span>
            <span class="value">
              {{
                metadata?.effectivePrice | CustomOfferCurrency:2
              }}
            </span>
          </div>
          <div class="counter-diagram-middle">
            <i>

              <svg width="32" height="32">
                <use xlink:href="#icon-arrow"></use>
              </svg>
            </i>
          </div>
          <div class="counter-diagram-right">
            <span class="name">Offer Price</span>
            <span class="value">{{metadata?.price | CustomOfferCurrency:2}}</span>
          </div>
        </div>

        <div class="counter-discount-wrap">
          <div class="counter-discount">
            <div class="counter-discount-left">
              <span class="name">Overall Discount</span>
            </div>
            <div class="counter-discount-right">
              <span class="price">
                {{
                  ((metadata?.effectivePrice * metadata?.quantity) - (metadata?.price * metadata?.quantity)) | CustomOfferCurrency:2
                }}
              </span>
              <span class="percent">
                ({{
                ( isBuyer ? getPercentOff() : totalPercentOff) |
                percent:'1.'+(offerService.offersSummary.validationRules.percentPrecision ||
                2)+'-'+(offerService.offersSummary.validationRules.percentPrecision || 2)
                }})
              </span>
            </div>
          </div>
        </div>

        <div class="counter-subtotal">

          <div class="counter-subtotal-values price">
            <span class="name">Offer Price</span>
            <span class="value">{{metadata?.price | CustomOfferCurrency:2}}</span>
          </div>

          <div class="counter-subtotal-values units">
            <span class="name">Units</span>
            <span class="value">{{metadata?.quantity | number:0:'en'}}</span>
          </div>
          <div class="counter-subtotal-values total">
            <span class="name">Total</span>
            <span class="value">{{(metadata?.price * metadata?.quantity) | CustomOfferCurrency:2}}</span>
          </div>

        </div>

        <div class="counter-buttons" *ngIf="!hideResponseButtons && isLastEvent && !previousOfferWasAccepted">
          <div class="counter-buttons-wrap" [class.no-rejectable]="isVendor"
            [class.last-offer]="metadata?.isFinal || priceOptions.length === 1">
            <a class="button" (click)="rejectOffer()" *ngIf="!isVendor" [class.disabled]="offerExpired">
              <span>Reject</span>
            </a>
            <a class="button" *ngIf="!metadata?.isFinal" (click)="onCounterOffer()" [class.disabled]="offerExpired">
              <span>Counter</span>
            </a>
            <a class="button button-accept" (click)="acceptOffer()" [class.disabled]="offerExpired">
              <span>Accept</span>
            </a>
          </div>
        </div>

        <div class="counter-buttons"
          *ngIf="hideResponseButtons && isLastEvent && !displayCounterOfferForm && !hideCancelButtonOnCounter && offerService.selectedOffer.status == FullOfferStatusEnum.Pending">
          <div class="counter-buttons-wrap">
            <a class="button button-cancel" (click)="cancelOffer()" [class.disabled]="offerExpired">
              <span>Cancel</span>
            </a>
            <a class="button button-edit" (click)="onEditOffer()" [class.disabled]="offerExpired">
              <span>Edit</span>
            </a>
          </div>
        </div>

        <div class="counter-buttons __accept-previous"
          *ngIf="hideResponseButtons && !isLastEvent && isCounterpartyPriorOffer && offerService.selectedOffer.status == FullOfferStatusEnum.Pending">
          <div class="counter-buttons-wrap">
            <a class="button button-accept" (click)="acceptPreviousOffer()"
              [class.disabled]="offerService.selectedOffer.status == !FullOfferStatusEnum.Pending || offerService.selectedOffer?.expired">
              <span>Accept</span>
            </a>
          </div>
          <div class="counter-buttons-info">
            <span>
              Change your mind? You can always accept the previous offer!
            </span>
          </div>
        </div>

      </div>
    </ng-container>

    <ng-container *ngIf="previousOfferWasAccepted && !isTyping">
      <div class="message-statuses">
        <div class="message-statuses__row">
          <svg height="24" width="24">
            <use xlink:href="#icon-arrow-previous"></use>
          </svg>
          <h4><span [innerHtml]="party"></span> Offer Accepted</h4>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="(displayCounterOfferForm && !offerWasAccepted && !offerWasTaken && !offerWasRejected && !orderWasCreated) || isEditOffer">
      <div class="counter-form animated" [class.flipmessage]="isEditOfferAnimate">
        <div class="counter-form-header">
          <h4 *ngIf="isEditOffer && offerService.selectedOffer.offerEvents.length === 1">Edit Offer</h4>
          <h4 *ngIf="isEditOffer && offerService.selectedOffer.offerEvents.length > 1">Edit Counteroffer</h4>
          <h4 *ngIf="!isEditOffer">Make Counteroffer</h4>
        </div>
        <div class="counter-form-group">
          <form [formGroup]="counterOfferForm">

            <!-- quantity -->
            <div class="counter-form-row">
              <div class="control" [class.__has-error]="counterOfferForm.get('quantity').invalid"
                [class.__has-error]="counterOfferForm.get('quantity').invalid || formErrors.quantity.validQuantityBasedOnAvailability === false">
                <div class="control__label">{{(isBuyer) ? 'I want' : 'Qty'}}
                  <span>
                    ({{offerService.selectedOfferItem?.availability | number:0:'en'}} Available)
                  </span>
                </div>
                <div>
                  <input type="text" [placeholder]="0" mask="0*" formControlName="quantity" pattern="[0-9]*" inputmode="numeric" appOnlyDigits>
                  <div class="control__postfix">unit(s)</div>
                </div>

                <div class="control__error">
                  <span *ngIf="counterOfferForm.get('quantity').invalid || formErrors.quantity.validQuantityBasedOnAvailability === false">
                    {{formErrorMsg_Quantity}}
                  </span>
                </div>
              </div>
            </div>

            <!-- price -->
            <div class="offer-row" [hidden]="true">
              <input type="text" formControlName="price" placeholder="$0">
            </div>

            <div class="counter-form-row">
              <div class="control" (click)="togglePriceDropdown()" (clickOutside)="priceDropdown.expanded=false" [attachOutsideOnClick]="true"
                [class.__has-error]="formErrors.price.validPrice === false || formErrors.price.validRegardsToMaxPrice === false">
                <div class="control__label">{{(isBuyer) ? 'I will pay' : 'Cost'}}
                  <span>
                    {{
                      metadata?.effectivePrice | CustomOfferCurrency:2
                    }}
                  </span>
                </div>
                <div class="app-dropdown">
                  <div class="app-dropdown-white">
                    <button class="btn dropdown-toggle" [class.active]="priceDropdown.valueWasSelectedByUser"
                      [class.expanded]="priceDropdown.expanded">
                      <span class="items-filter-select-name" *ngIf="!priceDropdown.selectedValue">
                        Select Unit Price
                      </span>
                      <span class="items-filter-select-name" *ngIf="priceDropdown.selectedValue">
                        {{priceDropdown.selectedValue | CustomOfferCurrency:2}} ({{priceDropdown.selectedPercent}})
                      </span>
                    </button>
                    <div class="dropdown-menu" [class.show]="priceDropdown.expanded">
                      <div class="dropdown-search-results">
                        <ng-container *ngFor="let priceOption of priceOptions; let i = index">
                          <div class="dropdown-separator" *ngIf="false"></div>
                          <a class="dropdown-item"
                            (click)="onSelectPrice(priceOption.price, priceOption.percent, $event)"
                            [style.pointer-events]="!priceOption.dropdownOptionDisabled ? '' : 'none'"
                            [class.rejected]="priceOption.dropdownOptionDisabled"
                            [class.active]="priceDropdown.selectedValue == priceOption.price && goodForDropdown.valueWasSelectedByUser">
                            <span class="dropdown-item__value">{{priceOption.price | CustomOfferCurrency:2}}</span>
                            <span class="dropdown-item__badge">{{priceOption.percent}}</span>
                            <span class="dropdown-item__label"
                              *ngIf="priceOption.dropdownOptionDisabled">Rejected</span>
                          </a>
                        </ng-container>
                      </div>
                    </div>

                    <div class="control__error">
                      <span *ngIf="formErrors.price.validPrice === false">
                        Your offer is too low, try again. Offers cannot be less than
                        {{offerService.offersSummary.validationRules.maxPercentage}}% off
                      </span>
                      <span *ngIf="formErrors.price.validRegardsToMaxPrice === false">
                        Amount should not exceed current list price
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Good For -->
            <div class="counter-form-row">
              <div class="control" (click)="toggleGoodForDropdown()" (clickOutside)="goodForDropdown.expanded=false" [attachOutsideOnClick]="true"
               [class.disabled]="false">
                <div class="control__label">My Offer is good for</div>
                <div class="app-dropdown">
                  <div class="app-dropdown-white">
                    <button class="btn dropdown-toggle" [class.active]="goodForDropdown.valueWasSelectedByUser"
                      [class.expanded]="goodForDropdown.expanded">
                      <span class="items-filter-select-name">
                        {{goodForDropdown.selectedValue}} Business Day{{goodForDropdown.selectedValue === 1 ? '' : 's'}}
                      </span>
                    </button>
                    <div class="dropdown-menu" [class.show]="goodForDropdown.expanded">
                      <div class="dropdown-search-results">
                        <a class="dropdown-item" (click)="onSelectDuration(1, $event)"
                          [class.active]="goodForDropdown.selectedValue === 1 && goodForDropdown.valueWasSelectedByUser">
                          1 Business Day
                        </a>
                        <a class="dropdown-item" (click)="onSelectDuration(2, $event)"
                          [class.active]="goodForDropdown.selectedValue === 2 && goodForDropdown.valueWasSelectedByUser"
                          [class.rejected]="rejectGoodForDropdownOption(2)">
                          <span class="dropdown-item__value">
                            2 Business Days
                          </span>
                        </a>
                        <a class="dropdown-item rejected" (click)="onSelectDuration(3, $event)"
                          [class.active]="goodForDropdown.selectedValue === 3 && goodForDropdown.valueWasSelectedByUser"
                          [class.rejected]="rejectGoodForDropdownOption(3)">
                          <span class="dropdown-item__value">
                            3 Business Days
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isEditOffer && false" class="app-dropdown-tooltip">
                    <span>Editing the offer will reset the timer to 1BD</span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- total offer -->
        <div class="counter-form-total"
          [class.filled]="counterOfferForm.get('quantity').value*priceDropdown.selectedValue > 0"
          [class.__has-error]="isEditingOfferMade() && !validTotalOffer">
          <div class="counter-form-total__name">
            Total Offer:
          </div>
          <div class="counter-form-total__value">
            {{(counterOfferForm.get('quantity').value*priceDropdown.selectedValue) | CustomOfferCurrency:2}}
          </div>
        </div>
         <div class="counter-form-total__error"
         *ngIf="isEditingOfferMade() && !validTotalOffer">
          <span>
            Only offers that with a minimum of ${{offerService.offersSummary.validationRules.minAmount/1000}}k will be
            considered.
          </span>
        </div>

        <!-- buttons -->
        <div class="counter-form-buttons">
          <a class="button" (click)="onBackCounterOffer()">
            <span>Back</span>
          </a>
          <a class="button button-submit" (click)="isEditOffer ? submitUpdateCounterOffer(): submitCounterOffer()"
            [class.disabled]="!validCounterofferForm()">
            <span>Submit Offer</span>
          </a>
        </div>
      </div>
    </ng-container>

    <!-- Statuses container -->
    <ng-container
      *ngIf="!isTyping && (offerWasAccepted || offerWasRejected || offerHasExpired || offerWasCancelled || offerWasTaken || (orderWasCreated && isVendor))">
      <div class="message-statuses">
        <div class="message-statuses__header">
          <ng-container *ngIf="orderWasCreated && isVendor && metadata?.purchaseOrder === null">
            <h4>Order Created</h4>
          </ng-container>
          <ng-container *ngIf="offerWasAccepted || offerWasTaken">
            <h4><span [innerHtml]="party"></span> Offer Accepted</h4>
          </ng-container>
          <ng-container *ngIf="offerWasRejected">
            <h4>Offer Rejected</h4>
          </ng-container>
          <ng-container *ngIf="offerWasCancelled">
            <h4>Offer Canceled</h4>
          </ng-container>
          <ng-container *ngIf="offerHasExpired">
            <h4>Offer Expired</h4>
          </ng-container>
        </div>
        <div class="message-statuses__text" *ngIf="false">
          <span>Available inventory is not enough</span>
        </div>
      </div>
    </ng-container>

    <!-- Order container -->
    <ng-container *ngIf="!isTyping && orderWasCreated && isBuyer">
      <div class="message-order">
        <div class="message-order__header">
          <h4>Order <span>#{{metadata?.salesOrder?.documentNumber}}</span> Created</h4>
        </div>
        <div class="message-order__button" *ngIf="!topService.isMobile">
          <a class="button" (click)="goToOrderDetails($event, metadata?.salesOrder?.documentId)">
            <span>View Sales Order</span>
          </a>
        </div>
      </div>
    </ng-container>

    <!-- Order container -->
    <ng-container *ngIf="!isTyping && orderWasCreated && isVendor && metadata?.purchaseOrder !== null">
      <div class="message-order">
        <div class="message-order__header">
          <h4>PO <span>#{{metadata?.purchaseOrder?.documentNumber}}</span> Created</h4>
        </div>
        <div class="message-order__button" *ngIf="!topService.isMobile">
          <a class="button" (click)="goToOrderDetails($event, metadata?.purchaseOrder?.documentId)">
            <span>View Purchase Order</span>
          </a>
        </div>
      </div>
    </ng-container>

    <!-- Notification container -->
    <ng-container *ngIf="false">
      <div class="message-notification">
        <div class="message-notification__header">
          <span>Seller rejected your offer, let you know when the price will be droped?</span>
        </div>
        <div class="message-notification__button">
          <a class="button">
            <span>Not now</span>
          </a>
          <a class="button">
            <span>Notify me</span>
          </a>
        </div>
      </div>
    </ng-container>

    <!-- Item container -->
    <ng-container *ngIf="false">
      <div class="message-item">
        <div class="message-item-top">
          <div class="message-item-logo">
            <div *ngIf="true">
              <img [src]="imageBaseUrl + '/assets/images/item-placeholder.svg'">
            </div>
            <div *ngIf="false">
              <img src="">
            </div>
          </div>
          <div class="message-item-exw">
            <div class="message-item-exw__name">EXW</div>
            <div class="message-item-exw__value">Miami</div>
          </div>
          <div class="message-item-notification">
            <i>
              <svg height="24" width="24">
                <use xlink:href="#icon-add-notification"></use>
              </svg>
            </i>
          </div>
        </div>
        <div class="message-item-middle">
          <div class="message-item-desc">
            <span>
              HP Omen 17-CK0010 Core™ i7-11800H 512GB SSD 16GB 17.3" (1920x1080) 144Hz IPS WIN10 NVIDIA® RTX 3060 6144MB
              SHADOW BLACK RGB Backlit Keyboard &nbsp; - &nbsp;
              <span class="copy-number">JBLCLIP3BLK-Z</span>
            </span>
          </div>
        </div>
        <div class="message-item-bottom">
          <div class="message-item-col">
            <div class="message-item-col-name">{{(isBuyer) ? 'List Price' : 'Cost'}}</div>
            <div class="message-item-col-value __price">$1,249</div>
          </div>
          <div class="item-col">
            <div class="message-item-col-name">In Stock</div>
            <div class="message-item-col-value">5</div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Typing container -->
    <ng-container *ngIf="isTyping">
      <div class="message-typing">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </ng-container>

    <i class="message-icon" *ngIf="!displayCounterOfferForm">
      <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icons/dialogue-angle-4px-border" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M12.0435639,-0.000504462342 L12,-0.0475044623 C16.4972424,4.71857377 18.9853066,8.85020155 19.4641925,12.3473789 C19.4761308,12.4345609 19.4641623,12.5594912 19.4282871,12.7221698 L19.3737616,12.9355034 L19.2962857,13.1850754 L19.1958593,13.4708857 C19.1772091,13.5215407 19.1576025,13.5737055 19.1370397,13.6273803 L19.0021877,13.9675483 L18.8443851,14.3439547 L18.6636322,14.7565996 L18.3494706,15.4435138 L18.1113415,15.9467546 L17.7111157,16.7695629 L17.0971547,17.993475 C17.0421662,18.1015074 16.9862214,18.2110497 16.9293204,18.322102 C12.6654297,21.409031 8.51117754,22.9524955 4.46656385,22.9524955 L6.18435274,21.1791755 L6.61316812,20.7260709 L7.02508918,20.278923 L7.29034578,19.9822704 L7.54813621,19.6854703 L7.79847746,19.3874049 L8.04138649,19.0869561 C8.08125292,19.0366206 8.12081038,18.9861392 8.16005923,18.9354886 L8.39185175,18.6293687 L8.61625449,18.3180706 L8.8332844,18.0004764 C8.86884259,17.9469572 8.90409429,17.8931292 8.93903985,17.8389689 L9.14504235,17.5098344 L9.34371445,17.1716089 L9.53507313,16.8231744 L9.71913535,16.4634132 L9.8959181,16.0912071 C9.98249242,15.9018066 10.0663433,15.70732 10.1474803,15.5071186 L10.3061386,15.0989096 L10.4575768,14.674343 C10.4822157,14.6021567 10.5065546,14.5292422 10.5305936,14.4555763 L10.6712335,14.0043772 L10.8046957,13.5340257 C10.8263422,13.4539757 10.8476904,13.373081 10.8687405,13.2913185 L10.991468,12.7901422 C11.0510466,12.5341604 11.1079494,12.2699484 11.1621861,11.9968773 L11.2671074,11.4387367 L11.3649358,10.855854 C11.3806504,10.7565829 11.3960702,10.6562343 11.4111955,10.554785 L11.4984166,9.93269293 C11.5123655,9.82674723 11.5260205,9.71965416 11.5393822,9.61139042 L11.616034,8.94757371 L11.685661,8.25454311 L11.7482799,7.5311807 L11.8039079,6.77636852 C11.8125976,6.64788357 11.8209967,6.51804164 11.8291056,6.38681942 L11.8742789,5.58273647 L11.9125037,4.74440892 C11.9182963,4.60177183 11.9238002,4.45766131 11.9290156,4.31205405 L11.9681754,2.96054822 L11.9856563,2.01277921 L11.9962565,1.02629383 L11.999993,-2.58560695e-05 L12.0435639,-0.000504462342 Z"
            id="bg"></path>
          <path
            d="M10.9999727,-3.96570248 L11,7 C11,8.25631834 11.1362782,9.48080721 11.3948582,10.6594904 L11.4111955,10.554785 C11.3960702,10.6562343 11.3806504,10.7565829 11.3649358,10.855854 L11.2671074,11.4387367 L11.1621861,11.9968773 C11.1079494,12.2699484 11.0510466,12.5341604 10.991468,12.7901422 L10.8687405,13.2913185 C10.8476904,13.373081 10.8263422,13.4539757 10.8046957,13.5340257 L10.6712335,14.0043772 L10.5305936,14.4555763 C10.5065546,14.5292422 10.4822157,14.6021567 10.4575768,14.674343 L10.3061386,15.0989096 L10.1474803,15.5071186 C10.0663433,15.70732 9.98249242,15.9018066 9.8959181,16.0912071 L9.71913535,16.4634132 L9.53507313,16.8231744 L9.34371445,17.1716089 L9.14504235,17.5098344 L8.93903985,17.8389689 L8.8332844,18.0004764 L8.61625449,18.3180706 L8.39185175,18.6293687 L8.16005923,18.9354886 C8.12081038,18.9861392 8.08125292,19.0366206 8.04138649,19.0869561 L7.79847746,19.3874049 L7.54813621,19.6854703 L7.29034578,19.9822704 L7.02508918,20.278923 L6.61316812,20.7260709 L6.18435274,21.1791755 L4.46656385,22.9524955 C8.20339385,22.9524955 12.0338109,21.6349998 15.9578149,19.0000082 C16.9427698,19.9878563 18.048661,20.8557707 19.251401,21.5790632 L19.2750027,21.5621289 C14.3696106,25.1134857 9.41989494,26.9524955 4.46656385,26.9524955 C0.933538198,26.9524955 -0.864667593,22.707054 1.59350993,20.1694107 L3.2791288,18.4296894 L3.67123128,18.0159035 L4.04327786,17.6126895 L4.27043001,17.3592743 L4.48514606,17.1129052 L4.6879219,16.8725601 L4.9057332,16.603475 C4.9290834,16.5738878 4.94075851,16.5590942 4.94893018,16.5487634 L4.97110657,16.520829 L5.14704005,16.2903097 L5.35456385,16.0004955 L5.5016038,15.7869036 C5.53047137,15.7432453 5.53768826,15.7323308 5.54299908,15.7245849 L5.72856385,15.4274955 L5.86556385,15.1944955 L5.99556385,14.9584955 L6.12956385,14.6964955 L6.25795644,14.4283076 C6.30509933,14.325172 6.35105649,14.220068 6.3869605,14.1352612 L6.41918503,14.058045 L6.55956385,13.6964955 L6.67201658,13.3822385 L6.67904578,13.3615931 L6.70727367,13.2782499 L6.71180767,13.2652512 L6.84256385,12.8414955 L6.94338013,12.4898792 C6.95501156,12.4468655 6.9665448,12.4035143 6.97456517,12.3734178 L6.98353423,12.3399131 L7.09559682,11.8833966 C7.14541868,11.6693349 7.19315465,11.447564 7.23104211,11.2578867 L7.32228197,10.7766546 L7.41413097,10.2304412 C7.42797612,10.1429798 7.44157397,10.0544834 7.44994071,9.99939308 L7.53264116,9.41055781 C7.54518246,9.31530284 7.55746943,9.2189348 7.56578573,9.15255363 L7.63606986,8.54771738 L7.70056478,7.90956721 L7.75909861,7.2371869 L7.81302481,6.50645724 C7.82119232,6.38569332 7.82909097,6.26358372 7.83540305,6.16245353 L7.8784305,5.40054 L7.91579815,4.5820972 C7.92133173,4.4458402 7.92659198,4.30810526 7.93069366,4.19620311 L7.96885557,2.88678376 L7.98588716,1.96979996 L7.99628297,1.0117312 L7.99656385,0.667495538 L7.97577931,0.551146055 C7.6411637,-1.47736081 9.1164296,-3.41990725 10.9999727,-3.96570248 Z"
            id="Combined-Shape" id="big-border" fill="#E0E0E0" fill-rule="nonzero"></path>
          <path
            d="M11.9992304,-0.000378561658 L11.9922735,1.48115673 L11.9785198,2.45077825 L11.9578641,3.38211913 L11.9302894,4.27630062 L11.8957786,5.13444396 L11.8543147,5.95767042 L11.8058807,6.74710123 L11.7504596,7.50385763 L11.6880344,8.22906089 L11.6185879,8.92383224 L11.5218805,9.75120971 L11.4141426,10.5349792 L11.3199881,11.1320687 L11.2187358,11.7037719 L11.1103688,12.2512101 L10.9948699,12.7755045 L10.8404413,13.4000346 L10.6748095,13.9923444 L10.4979411,14.5546239 L10.309803,15.089063 L10.1103618,15.5978515 L9.89958445,16.0831796 L9.72277812,16.456022 L9.53867829,16.8163725 L9.443888,16.9922137 L9.24881602,17.3359286 L9.14853008,17.5040826 L9.04640799,17.6699546 L8.8366469,17.9954131 L8.61951573,18.3134253 L8.33771165,18.7021772 L8.04433197,19.0832362 L7.80127146,19.384016 L7.55076427,19.6823951 L7.29279338,19.9794947 L6.89180538,20.4251978 L6.61510079,20.7240042 L6.18593243,21.1775233 L4.46656385,22.9524955 C8.3717081,22.9524955 12.3790599,21.5136416 16.4886194,18.6359337 L16.7931785,18.4196013 C17.0363311,18.6582513 17.2870722,18.8891963 17.5450066,19.1120411 L17.515741,19.1321087 C13.2389505,22.2283768 9.02864381,23.8429103 4.89401386,23.9471055 L4.46656385,23.9524955 L2.11323039,23.9524955 L3.7466895,22.2583911 L4.29370128,21.6941411 L5.8375946,20.0913193 L6.18786004,19.7132559 L6.58692952,19.2677634 L6.97358674,18.8123339 L7.26772067,18.4448666 L7.47961502,18.1665614 L7.68415827,17.8853076 L7.94562071,17.504735 L8.07159217,17.3116845 L8.31416395,16.9192142 C9.20060289,15.4302674 9.82765203,13.7385505 10.2516512,11.5249294 L10.3337604,11.0751519 L10.4349896,10.4528186 C10.477916,10.1703044 10.5181133,9.87976193 10.5556754,9.58065981 L10.6100537,9.12552051 L10.6843634,8.41786601 L10.7501747,7.67908145 L10.8077251,6.90782201 L10.857252,6.10274285 L10.8989928,5.26249915 L10.9331849,4.38574608 L10.9600657,3.4711388 L10.9798727,2.51733249 L10.9928432,1.52298233 L10.9992147,0.486743479 L10.9982304,-0.000378561658 L11.9992304,-0.000378561658 Z"
            id="border" fill="#E7E7E7" fill-rule="nonzero"></path>
        </g>
      </svg>
    </i>
  </div>



  <!-- User container -->
  <div [class.expanded]="isSpecialRole" class="message-after" *ngIf="!displayCounterOfferForm">
    <span class="name" *ngIf="isBuyer && !offerService.isSales && !isSpecialRole && offerEvent.userId !== null">
      {{offerEventTypeUsernameBuyer.get(offerEvent.eventType)}}
    </span>
    <span class="name" *ngIf="isVendor && !offerService.isVendorMgr && !isSpecialRole && offerEvent.userId !== null">
      {{offerEventTypeUserNameVendor.get(offerEvent.eventType)}}
    </span>


    <!-- isSales -->
    <ng-container *ngIf="isBuyer && offerService.isSales && !isSpecialRole && offerEvent.userId !== null">
      <span class="name">
        {{(userMessage)
        ? offerService.selectedOffer?.companiesInfo?.buyer.companyName
        : offerEventTypeUsernameBuyer.get(offerEvent.eventType)}}
      </span>
      <div class="message-after-additional">
        <span>
          {{(userMessage)
          ? offerService.selectedOffer?.companiesInfo?.buyer.phoneNumber
          : '' }}
        </span>
        <span>{{(userMessage)
          ? offerService.selectedOffer?.companiesInfo?.buyer.email
          : '' }}
        </span>
      </div>
    </ng-container>


    <!-- isVendor MGR -->
    <ng-container *ngIf="isVendor && offerService.isVendorMgr && !isSpecialRole && offerEvent.userId !== null">
      <span class="name">
        {{(userMessage)
        ? offerService.selectedOffer?.companiesInfo?.vendor.companyName
        : offerEventTypeUserNameVendor.get(offerEvent.eventType)}}
      </span>
      <div class="message-after-additional">
        <span>
          {{(userMessage)
          ? offerService.selectedOffer?.companiesInfo?.vendor.phoneNumber
          : '' }}
        </span>
        <span>{{(userMessage)
          ? offerService.selectedOffer?.companiesInfo?.vendor.email
          : '' }}
        </span>
      </div>
    </ng-container>

    <span class="name" *ngIf="offerEvent.userId === null && !isTyping">
      HUBX
    </span>


    <ng-container *ngIf="isSpecialRole && isBuyer && offerEvent.userId !== null">
      <span class="name">
        {{
          offerEvent.eventType === EventTypesEnum.SystemCancelledOffer
            ? offerEventTypeUsernameBuyer.get(offerEvent.eventType) : (userMessage)
              ? offerService.selectedOffer?.companiesInfo?.buyer.companyName
              : offerService.selectedOffer?.companiesInfo?.vendor.companyName
        }}
      </span>
      <div class="message-after-additional" *ngIf="offerEvent.eventType !== EventTypesEnum.SystemCancelledOffer">
        <span>{{(userMessage)
          ? offerService.selectedOffer?.companiesInfo?.buyer.phoneNumber
          :offerService.selectedOffer?.companiesInfo?.vendor.phoneNumber }}
        </span>
        <span>{{(userMessage)
          ? offerService.selectedOffer?.companiesInfo?.buyer.email
          : offerService.selectedOffer?.companiesInfo?.vendor.email }}
        </span>
      </div>
    </ng-container>


    <ng-container *ngIf="isSpecialRole && isVendor && offerEvent.userId !== null">
      <span class="name">
        {{(!userMessage)
        ? offerEvent.eventType === EventTypesEnum.OfferTaken ? offerService.selectedOffer?.companiesInfo?.taker?.companyName : offerService.selectedOffer?.companiesInfo?.buyer.companyName
        : offerService.selectedOffer?.companiesInfo?.vendor.companyName }}
      </span>
      <div class="message-after-additional">
        <span>{{(!userMessage)
          ? offerEvent.eventType === EventTypesEnum.OfferTaken ? offerService.selectedOffer?.companiesInfo?.taker?.phoneNumber : offerService.selectedOffer?.companiesInfo?.buyer.phoneNumber
          : offerService.selectedOffer?.companiesInfo?.vendor.phoneNumber }}
        </span>
        <span>{{(!userMessage)
          ? offerEvent.eventType === EventTypesEnum.OfferTaken ? offerService.selectedOffer?.companiesInfo?.taker?.email : offerService.selectedOffer?.companiesInfo?.buyer.email
          : offerService.selectedOffer?.companiesInfo?.vendor.email }}</span>
      </div>
    </ng-container>


    <span class="date" *ngIf="!isTyping && isBuyer && offerEventEdited">updated</span>
    <span class="date" *ngIf="!isTyping">{{offerEvent.timestamp | utcToNowOffers: fromOfferList}}</span>
    <span class="date" *ngIf="isTyping">typing...</span>
    <span class="date" *ngIf="!isTyping && isVendor && offerEventEdited">updated</span>
  </div>

  <!-- Info container -->
  <div class="message-info"
    *ngIf="!displayCounterOfferForm && isLastEvent && !isTyping &&
    [EventTypesEnum.OfferMade, EventTypesEnum.BuyerCounteroffered, EventTypesEnum.VendorCounteroffered,
      EventTypesEnum.VendorRejectedOffer, EventTypesEnum.BuyerRejectedOffer,
    EventTypesEnum.BuyersOfferExpired, EventTypesEnum.VendorsOfferExpired,
    EventTypesEnum.SystemCancelledOffer, EventTypesEnum.OrderCreated,
    EventTypesEnum.BuyerCancelledOffer, EventTypesEnum.VendorCancelledOffer, EventTypesEnum.BuyerUpdatedOfferEvent, EventTypesEnum.VendorUpdatedOfferEvent].includes(offerEvent.eventType)">
    <div class="message-info__line">
    </div>
    <div class="message-info__text" [ngSwitch]="offerEvent.eventType">


      <!-- offer rejected -->
      <span *ngSwitchCase="EventTypesEnum.VendorRejectedOffer">
        <span class="emoji" [innerHtml]="ex"></span>
        {{getOfferRejectedMessage()}}
      </span>
      <span *ngSwitchCase="EventTypesEnum.BuyerRejectedOffer">
        <span class="emoji" [innerHtml]="ex"></span>
        {{getOfferRejectedMessage()}}
      </span>
      <!-- <span *ngSwitchCase="EventTypesEnum.VendorRejectedOffer">
        <span *ngIf="isBuyer">
          Offer has been rejected by the vendor
        </span>
        <span *ngIf="isVendor && offerEvent.userId === userId">
          You have rejected this offer
        </span>
        <span *ngIf="isVendor && offerEvent.userId !== userId">
          Someone on your team has rejected this offer
        </span>
      </span>

      <span *ngSwitchCase="EventTypesEnum.BuyerRejectedOffer">
        <span *ngIf="isBuyer && offerEvent.userId === userId">
          You have rejected the vendor’s counteroffer
        </span>
        <span *ngIf="isBuyer && offerEvent.userId !== userId">
          Someone on your team has rejected the vendor’s counteroffer
        </span>
        <span *ngIf="isVendor">
          Counteroffer has been rejected by the Buyer
        </span>
      </span> -->


      <span *ngSwitchCase="EventTypesEnum.BuyersOfferExpired">
        <!-- {{isBuyer ? 'Your offer has timed out (expired)': isVendor && 'Offer has timed out (expired)'}} -->
        <span class="emoji" [innerHtml]="ex"></span>
        {{getOfferExpiredMessage()}}
      </span>

      <span *ngSwitchCase="EventTypesEnum.VendorsOfferExpired">
        <!-- {{isBuyer ? 'Your offer has timed out (expired)': isVendor && 'Offer has timed out (expired)'}} -->
        <span class="emoji" [innerHtml]="ex"></span>
        {{getOfferExpiredMessage()}}
      </span>

      <!-- offer canceled by system -->
      <span *ngSwitchCase="EventTypesEnum.SystemCancelledOffer">
        <!-- {{isBuyer ? 'Your offer has been canceled': isVendor && 'Offer has been canceled'}} -->
        <span *ngIf="!offerCanceledDueToFeatureSwitched">
          <span class="emoji" [innerHtml]="ex"></span>
          {{getOfferCanceledMessage()}} <br>
          {{offerCancellationReason}}
        </span>
        <span *ngIf="offerCanceledDueToFeatureSwitched">
          <span class="emoji" [innerHtml]="lock"></span>
          {{getOfferCanceledMessage()}}
        </span>
      </span>

      <!-- Offer canceled by user -->
      <span *ngSwitchCase="EventTypesEnum.BuyerCancelledOffer">
        <span class="emoji" [innerHtml]="ex"></span>
        {{isVendor ? 'The offer has been canceled by the buyer' : 'You canceled the offer'}}
      </span>
      <span *ngSwitchCase="EventTypesEnum.VendorCancelledOffer">
        <span class="emoji" [innerHtml]="ex"></span>
        {{isBuyer ? 'The offer has been canceled by the vendor' : 'You canceled the offer'}}
      </span>

      <!-- offer made  -->
      <span *ngSwitchCase="EventTypesEnum.OfferMade">
        <span *ngIf="isBuyer">
          <span class="emoji" [innerHtml]="check"></span>
          Your offer has been sent, the seller has
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
        <span *ngIf="isVendor">
          <span class="emoji" [innerHtml]="watch"></span>
          Buyer sent you an offer, you have
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
      </span>

      <!-- counteroffer -->
      <span *ngSwitchCase="EventTypesEnum.BuyerCounteroffered">
        <span *ngIf="isBuyer">
          <span class="emoji" [innerHtml]="check"></span>
          Your counteroffer has been sent, the seller has
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
        <span *ngIf="isVendor">
          <span class="emoji" [innerHtml]="watch"></span>
          Buyer sent you {{metadata?.isFinal ? 'last': 'a'}} counteroffer, you have
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
      </span>

      <span *ngSwitchCase="EventTypesEnum.VendorCounteroffered">
        <span *ngIf="isVendor">
          <span class="emoji" [innerHtml]="check"></span>
          Your counteroffer has been sent, the buyer has
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
        <span *ngIf="isBuyer">
          <span class="emoji" [innerHtml]="check"></span>
          Seller sent you {{metadata?.isFinal ? 'last': 'a'}} counteroffer, you have
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
      </span>

      <!-- offer accepted -->
      <span *ngSwitchCase="EventTypesEnum.OrderCreated">
        <span>
          <span class="emoji" [innerHtml]="party"></span>
          {{getOrderCreatedMessage()}}
          <span *ngIf="isBuyer" class="order">#{{metadata?.salesOrder?.documentNumber}}</span>
          <span *ngIf="isVendor && metadata?.purchaseOrder"
            class="order">#{{metadata?.purchaseOrder?.documentNumber}}</span>
          was created
        </span>
      </span>

      <!-- offer updated -->
      <span *ngSwitchCase="EventTypesEnum.BuyerUpdatedOfferEvent">
        <span *ngIf="isBuyer">
          <span class="emoji" [innerHtml]="check"></span> You updated offer<span
            [innerHtml]="offerUpdatedMessage"></span>, the seller has
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
        <span *ngIf="isVendor">
          <span class="emoji" [innerHtml]="watch"></span> Buyer updated offer<span
            [innerHtml]="offerUpdatedMessage"></span>, you have
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
      </span>
      <span *ngSwitchCase="EventTypesEnum.VendorUpdatedOfferEvent">
        <span *ngIf="isBuyer">
          <span class="emoji" [innerHtml]="watch"></span> Seller updated offer<span
            [innerHtml]="offerUpdatedMessage"></span>, you have
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
        <span *ngIf="isVendor">
          <span class="emoji" [innerHtml]="check"></span> You updated offer<span
            [innerHtml]="offerUpdatedMessage"></span>, buyer has
          <span class="timer">
            <app-generic-countdown *ngIf="offerService.selectedOffer?.expiresOn"
              [utcDate]="offerService.selectedOffer?.expiresOn"
              [source]="GenericCountdownSourceEnum.counteroffer"></app-generic-countdown>
          </span>
          to respond
        </span>
      </span>

    </div>
  </div>
</div>
